﻿import React from 'react';
import ReactModal from 'react-modal';
import VeilederRenterDto from './Models/VeilederRenterDto';
import * as Ids from './Models/Ids';
import BoksA from './Components/BoksA';
import BoksB from './Components/BoksB';

interface AppOwnProps {
    side: VeilederRenterDto,
}
type AppProps = AppOwnProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);

export default class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        if (this.props.side !== null) {

            return (
                <div className="c-veileder">
                    <BoksA side={this.props.side} />
                    <BoksB side={this.props.side} />
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}
